import { render, staticRenderFns } from "./WeightInputField.vue?vue&type=template&id=9666cdaa&scoped=true"
import script from "./WeightInputField.vue?vue&type=script&lang=ts"
export * from "./WeightInputField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9666cdaa",
  null
  
)

export default component.exports